import PropTypes from 'prop-types'

import TextField from './TextField'

const NumericFieldWithIncrement = ({
  onIncrement,
  onDecrement,
  containerStyle,
  onlyPositive,
  allowZero = false,
  ...rest
}) => {
  const handleClick = (increment) => {
    if (increment) {
      return onIncrement({ target: { name: rest.name, value: Number(rest.value) + 1 } })
    }
    if (onlyPositive) {
      if (
        (allowZero && Number(rest.value) - 1 >= 0) ||
        (!allowZero && Number(rest.value) - 1 > 0)
      ) {
        return onDecrement({ target: { name: rest.name, value: Number(rest.value) - 1 } })
      }
    } else {
      return onDecrement({ target: { name: rest.name, value: Number(rest.value) - 1 } })
    }
  }

  return (
    <div style={{ position: 'relative', ...containerStyle }}>
      <TextField
        {...rest}
        type="number"
        onChange={(e) => {
          rest.onChange({ target: { name: rest.name, value: e.target.value } })
        }}
      />
      <button
        onClick={() => handleClick(true)}
        type="button"
        className="button numeric-input increment button-transparent"
      >
        +
      </button>
      <button
        onClick={() => handleClick(false)}
        type="button"
        className="button numeric-input decrement button-transparent"
      >
        -
      </button>
    </div>
  )
}

NumericFieldWithIncrement.propTypes = {
  onIncrement: PropTypes.func,
  onDecrement: PropTypes.func,
  containerStyle: PropTypes.object,
  onlyPositive: PropTypes.bool,
  allowZero: PropTypes.bool,
}

export default NumericFieldWithIncrement
